import { Group, Button, ActionIcon, Tooltip } from "@mantine/core";
import { X, Save } from "lucide-react";

export interface ChartEditActionsButtonProps {
    handleCancel: () => void;
    handleSave: () => void;
    isSaving: boolean;
}

export function ChartEditActionsButton({
    handleCancel,
    handleSave,
    isSaving,
}: ChartEditActionsButtonProps) {
    return (
        <Group justify="flex-end" gap="sm">
            <Tooltip label="Cancel">
                <ActionIcon
                    variant="outline"
                    color="gray"
                    onClick={handleCancel}
                    disabled={isSaving}
                    hiddenFrom="sm"
                    size="lg"
                >
                    <X size={18} />
                </ActionIcon>
            </Tooltip>
            <Button
                variant="outline"
                color="gray"
                onClick={handleCancel}
                disabled={isSaving}
                visibleFrom="sm"
                leftSection={<X size={16} />}
            >
                Cancel
            </Button>

            <Tooltip label="Save Changes">
                <ActionIcon
                    color="black"
                    c="white"
                    onClick={handleSave}
                    disabled={isSaving}
                    loading={isSaving}
                    hiddenFrom="sm"
                    size="lg"
                >
                    <Save size={18} />
                </ActionIcon>
            </Tooltip>
            <Button
                color="black"
                c="white"
                onClick={handleSave}
                disabled={isSaving}
                loading={isSaving}
                visibleFrom="sm"
                leftSection={<Save size={16} />}
            >
                Save Changes
            </Button>
        </Group>
    );
}
